import { AppData, Log } from "@lightningjs/sdk";

import { AppState } from "./app-state";
import { AppSetup } from "./app-setup";
import GridViewModel from "./components/grid/grid-view-model";
import { addToQueue, fetchData, removeFromQueue } from "./models/data-service";
import EventEmitter from "eventemitter3";
import Router from "@lightningjs/sdk/src/Router";
import { GRIDTYPE } from "./enum";
import RowList from "./components/grid/row-model";


export default class QueueManager extends EventEmitter {

  queueGrid!: GridViewModel

  init() {

    this.reloadQueueRow()
  }

  isQueueAvailable(): boolean {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    const mainGridList: GridViewModel[] = app?.navigation.continuesStack.filter(gridview => {
      return gridview.type == GRIDTYPE.GRID
    })!
    const mainGrid = mainGridList[0]!
    const queueRowList: RowList = app?.queueGrid.getRowAt(0)!
    if (queueRowList) {
      return true
    } else {
      return false
    }
  }

  isAddedToQueue(nodeType: string, nodeId: number): boolean {
    if (!this.queueGrid) return false;
    const rowListInfo = this.queueGrid.gridModel.getRowAtIndex(0);
    if (!rowListInfo) return false;
    const videos = rowListInfo.rowList.videos;
    return videos.some((element: any) =>
      nodeType === 'show' ? element.id == nodeId : element.node_id == nodeId
    );
  }

  showQueueRow() {
    this.updateQueueRowMainGrid(true)
  }

  addToQueue(type: string, id: number, title:string = '') {
    const url = addToQueue(type, id)
    fetchData(url)
      .then((data) => {
        Log.info('QueueManager: addToQueue Success: ', data.data)
        if (data.data.status) {
          this.reloadQueueRow(true)
            .then(() => {
              this.updateQueueRowMainGrid()
              this.emit('added')
              Router.getActivePage()?.widgets.notification.showNotification(`Successfully added "${title}" to Queue List !`)
            })
        } else {
          Log.error('QueueManager: addToQueue: fail', data.data.description);
          this.emit('error', data.data.description)
        }
      })
      .catch((error) => {
        Log.error('QueueManager: addToQueue: fail', [error]);
        this.emit('error', error)
      })

  }

  removeFromQueue = (type: string, id: number, title:string = '', clearAll: boolean = false) => {
    //loaderComponent.showLoader();
    const url = removeFromQueue(type, id, clearAll);
    fetchData(url)
      .then((data) => {
        Log.info('QueueManager: removeFromQueue: ', data.data)
        if (data.data.status) {
          this.reloadQueueRow(true)
            .then(() => {
              this.updateQueueRowMainGrid()
              this.emit('removed')
              Router.getActivePage()?.widgets.notification.showNotification(
                 clearAll
                     ? `${data?.data?.description}`
                     : `Successfully removed "${title}" from Queue List!`
              )
            })
        } else {
          Log.error('QueueManager: removeFromQueue: fail', data.data.description);
          this.emit('error', data.data.description)
        }
      })
      .catch((error) => {
        Log.error('error', 'fetching items: fail', [error]);
      })
  }

  updateQueueRowMainGrid(showQueueRow = false) {
    const { appState } = AppData as AppSetup
    const app = appState?.getApp()
    const shouldReloadQueue = false;
    const mainGridList: GridViewModel[] = app?.navigation.continuesStack.filter(gridview => {
      return gridview.type == GRIDTYPE.GRID
    })!
    if(mainGridList.length == 0) return;
    const mainGrid = mainGridList[0]!
    const uiQueRow: any = mainGrid.getQueueRow()
    const recentlyRow: any = mainGrid.getRowByName('recently watched')
    const queueRowList: RowList = app?.queueGrid.getRowAt(0)!
    const queueUiRowList: RowList = app?.queueGrid.getUiRowAt(0)!
    const oldFocus = mainGrid.getFocusInfo()
    let insertRowIndex = (!recentlyRow) ? 0 : 1
    if (queueRowList) {
      if (uiQueRow) {
        insertRowIndex = uiQueRow.data.rowUIIndex
        uiQueRow.data.item.rowList = queueRowList
        mainGrid.update(queueRowList, insertRowIndex, queueUiRowList)
      } else {
        mainGrid.add(queueRowList, insertRowIndex, queueUiRowList)
      }
    } else {
      if (uiQueRow) {
        mainGrid.remove(uiQueRow.data.rowUIIndex)
        oldFocus.focusRow = oldFocus.focusRow > uiQueRow.data.rowUIIndex ? oldFocus.focusRow - 1 : oldFocus.focusRow
        mainGrid.focusInfo = oldFocus
      }
    }
    if (showQueueRow) {
      oldFocus.focusRow = insertRowIndex
      mainGrid.focusInfo = oldFocus
      mainGrid.emit('refocus', mainGrid.focusInfo)
    }
  }

  async reloadQueueRow(reload = false) {
    const { appState, appConfig } = AppData as AppSetup
    if (appConfig?.enableQueueManagement) {
      const app = appState?.getApp()
      this.queueGrid = app?.loadQueuePlaylist(reload)!
      await this.queueGrid.fetchInitialRows()
      this.queueGrid.createGridListUI()
      return true
    }
    return false
  }

}
